import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import MCLoading from "../Loading"

const MCLoadingOverlay = ({show}) => {
    return show ? (

        <div className='mc-loading-overlay'>

            <MCLoading/>
        </div>
    ) : null
}

MCLoadingOverlay.propTypes = {
    show: PropTypes.bool,
}

MCLoadingOverlay.defaultProps = {
    show: false,
}

export default MCLoadingOverlay



// WEBPACK FOOTER //
// ./src/components/_minha-central/LoadingOverlay/index.js